module.exports = __webpack_public_path__ + "static/media/key.67ab4f73.svg";